import { Pipe, PipeTransform } from '@angular/core';
import { ObjectDefinitionModel } from '@base/modules/rest/bbs-object/model/object-definition.model';
import { CustomFieldModel } from '@base/modules/rest/custom-field/model/custom-field.model';

@Pipe({
  name: 'findFieldByName'
})
export class FindFieldByNamePipe implements PipeTransform {

  transform(name: string, objectDefinition: ObjectDefinitionModel): CustomFieldModel {
    return objectDefinition.fields?.find(f => f.dbName === name);
  }

}
